import { useEffect, useRef } from "react";

export default function AutoTextarea({ value, onChange, placeholder }) {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // reset
      textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    }
  }, [value]); // run whenever value changes

  return (
    <textarea
      ref={textareaRef}
      className="form-control form-control-sm lato-textarea"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows={1}
      onInput={(e) => {
        e.target.style.height = "auto";
        e.target.style.height = e.target.scrollHeight + "px";
      }}
    />
  );
}
